"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.iterator.reduce.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.set.js");
require("core-js/modules/es.set.difference.v2.js");
require("core-js/modules/es.set.intersection.v2.js");
require("core-js/modules/es.set.is-disjoint-from.v2.js");
require("core-js/modules/es.set.is-subset-of.v2.js");
require("core-js/modules/es.set.is-superset-of.v2.js");
require("core-js/modules/es.set.symmetric-difference.v2.js");
require("core-js/modules/es.set.union.v2.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _IceLabel = _interopRequireDefault(require("@/components/common/IceLabel.vue"));
var _index = _interopRequireDefault(require("@/components/IceQueryGrid/index.vue"));
var _IceTreeGrid = _interopRequireDefault(require("./IceTreeGrid.vue"));
var _vuescroll = _interopRequireDefault(require("vuescroll"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'IcePopSelector',
  model: {
    prop: 'value',
    event: 'input' // 添加事件配置
  },
  props: {
    label: String,
    // 选择控件标签文本
    labelWidth: {
      // 标签宽度
      type: Number,
      default: 100
    },
    title: {
      // 弹出框标题
      type: String,
      default: '请选择'
    },
    icon: {
      type: String,
      default: 'el-icon-edit-outline'
    },
    dialogWidth: {
      // 弹出框宽度
      type: Number,
      default: 1000
    },
    chooseItem: {
      // 网格是否可选择【'single', 'multiple'】
      type: String,
      default: 'multiple',
      validator: function validator(value) {
        return ['single', 'multiple'].indexOf(value) !== -1;
      }
    },
    height: {
      // 弹出框高度
      type: Number,
      default: 470
    },
    value: String,
    // 值绑定v-model,
    mode: {
      type: String,
      default: 'input',
      validator: function validator(value) {
        return ['input', 'onlySelect', 'readonly', 'hidden'].indexOf(value) !== -1;
      }
    },
    extendProp: [String, Number, Array, Object],
    selections: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    selectListWidth: {
      // 侧边已选列表宽度
      type: String,
      default: '200px'
    },
    buttonDisabled: {
      type: Boolean,
      default: true
    },
    // 是否显示清除按钮
    isShowClear: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      selectedValue: '',
      confirmButton: true,
      visible: false,
      selectedItems: this.selections.map(function (item) {
        return item;
      }),
      // 已选列表清单
      selectedItemsMap: {},
      // 用于快速过滤数据，防止页面卡死
      showTotal: false // 是否查看所有已选列表，默认最多显示100条
    };
  },
  methods: {
    btnClearable: function btnClearable() {
      // 重置内部状态
      this.selectedValue = '';
      this.selectedItems = [];
      this.selectedItemsMap = {};

      // 清除网格中的选中状态
      if (this.$refs.queryGridPop) {
        this.$refs.queryGridPop.cleanColumnSelect();
      }
      if (this.$refs.queryTreeGridPop) {
        this.$refs.queryTreeGridPop.cleanColumnSelect();
      }
      this.$emit('btnClearable');
      this.$emit('btn-clearable');
    },
    selectConfirm: function selectConfirm() {
      var _this = this;
      var texts = this.selectedItems.map(function (item) {
        return item[_this.textProp];
      }).join(',');
      var values = this.selectedItems.map(function (item) {
        return item[_this.codeProp];
      }).join(',');
      this.$emit('selectConfirm', this.selectedItems, texts, values);
      this.$emit('select-confirm', this.selectedItems, texts, values);
      this.selectCannel();
    },
    dbclick: function dbclick(data) {
      this.selectChange([data], []);
      this.selectConfirm();
    },
    selectCannel: function selectCannel() {
      var _this2 = this;
      this.visible = false;
      // this.$emit('update:visible', false);
      this.$nextTick(function () {
        if (_this2.$refs.queryGridPop) {
          _this2.$refs.queryGridPop.resetQuery();
        }
      });
      this.$emit('selectCannel');
      this.$emit('select-cannel');
    },
    openDialog: function openDialog() {
      var _this3 = this;
      this.visible = true;
      /* 阻止对话框打开 */
      var stop = function stop() {
        _this3.visible = false;
      };
      /* 刷新数据 */
      var refresh = function refresh() {
        var _this3$$refs$queryGri;
        (_this3$$refs$queryGri = _this3.$refs.queryGridPop) === null || _this3$$refs$queryGri === void 0 || _this3$$refs$queryGri.resetQuery();
      };
      this.$emit('dialogChange', stop, refresh);
      this.$emit('dialog-change', stop, refresh);
      this.$nextTick(function () {
        if (_this3.$refs.queryGridPop) {
          _this3.$refs.queryGridPop.doLayout();
          _this3.$refs.queryGridPop.cleanColumnSelect();
        }
      });
    },
    cleanColumnSelect: function cleanColumnSelect() {
      if ((this.$attrs.dataUrl || this.$attrs['data-url']) && (this.$attrs.loadUrl || this.$attrs['load-url'])) {
        if (this.$refs.queryTreeGridPop) {
          this.$refs.queryTreeGridPop.radio = '';
          this.$refs.queryTreeGridPop.cleanColumnSelect();
        }
      } else {
        if (this.$refs.queryGridPop) {
          this.$refs.queryGridPop.radio = '';
          this.$refs.queryGridPop.cleanColumnSelect();
        }
      }
    },
    selectChange: function selectChange(rows, removerows) {
      var _this4 = this;
      if (this.chooseItem == 'single') {
        this.selectedItems = rows;
        this.selectedItemsMap = rows.reduce(function (map, item) {
          map[item[_this4.codeProp]] = item;
          return map;
        }, {});
      } else {
        // 使用 Set 优化查找
        var existingKeys = new Set(Object.keys(this.selectedItemsMap));
        var newRows = rows.filter(function (item) {
          return !existingKeys.has(item[_this4.codeProp]);
        });
        newRows.forEach(function (item) {
          _this4.selectedItems.push(item);
          _this4.selectedItemsMap[item[_this4.codeProp]] = item;
        });
        if (removerows && removerows.length > 0) {
          var removeKeys = new Set(removerows.map(function (item) {
            return item[_this4.codeProp];
          }));
          this.selectedItems = this.selectedItems.filter(function (item) {
            return !removeKeys.has(item[_this4.codeProp]);
          });
          removerows.forEach(function (item) {
            delete _this4.selectedItemsMap[item[_this4.codeProp]];
          });
        }
      }
    },
    closeTag: function closeTag(value) {
      var _this5 = this;
      var selectedItems = this.selectedItems;
      this.selectedItems = [];
      this.selectedItemsMap = {};
      selectedItems.forEach(function (item) {
        if (item[_this5.codeProp] != value) {
          _this5.selectedItems.push(item);
          _this5.selectedItemsMap[item[_this5.codeProp]] = item;
        }
      });
      if ((this.$attrs.dataUrl || this.$attrs['data-url']) && (this.$attrs.loadUrl || this.$attrs['load-url'])) {
        var _this$$refs$queryTree;
        (_this$$refs$queryTree = this.$refs.queryTreeGridPop) === null || _this$$refs$queryTree === void 0 || _this$$refs$queryTree.closeSelection(value); // 添加可选链
      } else {
        var _this$$refs$queryGrid;
        (_this$$refs$queryGrid = this.$refs.queryGridPop) === null || _this$$refs$queryGrid === void 0 || _this$$refs$queryGrid.closeSelection(value); // 添加可选链
      }
    },
    setChecked: function setChecked(key_data, checked, deep) {
      this.$refs.queryTreeGridPop.setChecked(key_data, checked, deep);
    },
    getCheckedNodes: function getCheckedNodes(leafOnly, includeHalfChecked) {
      return this.$refs.queryTreeGridPop.getCheckedNodes(leafOnly, includeHalfChecked);
    },
    setCheckedNodes: function setCheckedNodes(nodes) {
      this.$refs.queryTreeGridPop.setCheckedNodes(nodes);
    },
    setCheckedKeys: function setCheckedKeys(keys, leafOnly) {
      this.$refs.queryTreeGridPop.setCheckedKeys(keys, leafOnly);
    },
    reDoSelection: function reDoSelection() {
      if (this.$refs.queryTreeGridPop) {
        this.$refs.queryTreeGridPop.reDoSelection();
      }
      if (this.$refs.queryGridPop) {
        this.$refs.queryGridPop.reDoSelection();
      }
    }
  },
  computed: {
    codeProp: function codeProp() {
      var codeProp = this.$attrs.codeProp;
      if (!codeProp) {
        codeProp = this.$attrs['code-prop'];
      }
      return codeProp;
    },
    textProp: function textProp() {
      var textProp = this.$attrs.textProp;
      if (!textProp) {
        textProp = this.$attrs['text-prop'];
      }
      return textProp;
    },
    // 添加新的计算属性来过滤已选项
    filteredSelectedItems: function filteredSelectedItems() {
      if (this.showTotal) {
        return this.selectedItems;
      } else {
        return this.selectedItems.slice(0, 100);
      }
    }
  },
  watch: {
    value: function value(newvalue) {
      this.selectedValue = newvalue;
    },
    visible: function visible() {
      this.$emit('update:visible', this.visible);
    },
    selectedValue: function selectedValue(newValue) {
      this.$emit('input', newValue); // 触发input事件
    },
    selections: function selections() {
      var _this6 = this;
      if (this.selections) {
        this.selectedItems = this.selections.map(function (item) {
          return item;
        });
        this.selectedItems.forEach(function (item) {
          _this6.selectedItemsMap[item[_this6.codeProp]] = item;
        });
      }
    }
  },
  mounted: function mounted() {
    var _this7 = this;
    this.selectedValue = this.value;
    this.selectedItems.forEach(function (item) {
      _this7.selectedItemsMap[item[_this7.codeProp]] = item;
    });
  },
  components: {
    IceTreeGrid: _IceTreeGrid.default,
    IceQueryGrid: _index.default,
    IceLabel: _IceLabel.default,
    VueScroll: _vuescroll.default
  }
};